<template>
    <div class="mt-3 bg-gray" v-if="trainee_followups.length > 0">
        <h4>Training follow-up</h4>
        <hr/>
        <div v-if="trainee_followups.length > 0">
            <h5 class="mb-3">Before training:</h5>
            <div v-for="(trainee_followup, index) in trainee_followups" :key="index">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">Question 1</strong
                                >
                                {{ trainee_followup.question_1 }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1"
                                >Question 2</strong>
                                {{ trainee_followup.question_2 }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">Question 3</strong>
                                {{ trainee_followup.question_3 }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">Question 4</strong>
                                {{ trainee_followup.question_4 }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1"
                                >Question 5</strong>
                                {{ trainee_followup.question_5 }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">Remarks</strong>
                                {{ trainee_followup.remarks }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">Date</strong>
                                {{ trainee_followup.date }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <h5 v-if="trainee_followup_seconds.length > 0" class="mb-3">After training:</h5>
            <div v-if="trainee_followup_seconds.length > 0">
                <h6  style="font-weight: bold" class="mb-3">Second training followup:</h6>
                <div v-for="(trainee_followup_second, index) in trainee_followup_seconds" :key="index">
                    <h5 class="mb-2" style="font-weight: bold;">Date: {{ trainee_followup_second.date }}</h5>
                    <hr>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Question 1</strong
                                    >
                                    {{ trainee_followup_second.question_1 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Question 2</strong>
                                    {{ trainee_followup_second.question_2 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Question 3</strong>
                                    {{ trainee_followup_second.question_3 }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Question 4</strong>
                                    {{ trainee_followup_second.question_4 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Question 5</strong>
                                    {{ trainee_followup_second.question_5 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Date</strong>
                                    {{ trainee_followup_second.date }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Remarks</strong>
                                    {{ trainee_followup_second.remarks }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="trainee_followup_lasts.length > 0">
                <h6  style="font-weight: bold" class="mb-3">Last training followup:</h6>
                <div v-for="(trainee_followup_last, index) in trainee_followup_lasts" :key="index">
                    <h5 class="mb-2" style="font-weight: bold;">Date: {{ trainee_followup_last.date }}</h5>
                    <hr>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Question 1</strong
                                    >
                                    {{ trainee_followup_last.question_1 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Question 2</strong>
                                    {{ trainee_followup_last.question_2 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Question 3</strong>
                                    {{ trainee_followup_last.question_3 }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Question 4</strong>
                                    {{ trainee_followup_last.question_4 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Question 5</strong>
                                    {{ trainee_followup_last.question_5 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Date</strong>
                                    {{ trainee_followup_last.date }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Remarks</strong>
                                    {{ trainee_followup_last.remarks }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import http from "@state/http";

    export default {
        props: ["trainee_id"],
        components: { },
        data() {
            return {
                flag: false,
                trainee_followups: [],
                trainee_followup_seconds: [],
                trainee_followup_lasts: [],
            };
        },


        mounted() {
            this.getTraineeFollowup();
            this.getTraineeFollowupSecond();
            this.getTraineeFollowupLast();
        },
        methods: {
            async getTraineeFollowup() {
                await http.get("api/trainee/mansion-work/followup/list/" + this.trainee_id)
                    .then(resource => {
                        this.trainee_followups = resource.data.trainee_followups
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            async getTraineeFollowupSecond() {
                await http.get("api/trainee/mansion-work/followup-second/list/" + this.trainee_id)
                    .then(resource => {
                        this.trainee_followup_seconds = resource.data.trainee_followup_seconds
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            async getTraineeFollowupLast() {
                await http.get("api/trainee/mansion-work/followup_last/list/" + this.trainee_id)
                    .then(resource => {
                        this.trainee_followup_lasts = resource.data.trainee_followup_lasts
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
        },
    };
</script>

<style scoped>

</style>